module.exports = __webpack_public_path__ + "static/media/1.be109465.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/baliza/1.jpg
// module id = 507
// module chunks = 0